﻿import { DragZoom } from 'ol/interaction';
export default class NavigationToolbarControl {
    constructor(action, resourcesHandler, layerSettingsHandler, menuContainer, rootURL, classId, mapControl) {
        this.action = action;
        this.resourcesHandler = resourcesHandler;
        this.layerSettingsHandler = layerSettingsHandler;
        this.menuContainer = menuContainer;
        this.rootURL = rootURL;
        this.classId = classId;
        this.mapControl = mapControl;

        this.toolbarActions = [
            { action: "navigation-refresh", icon: "fal fa-sync", title: this.resourcesHandler.get("Refresh"), handler: (() => { this._disableControls("navigation-refresh"); this.mapControl.refresh(); }), options: null },
            { action: "navigation-fit", icon: "ni ni-size-actual", title: this.resourcesHandler.get("Fit"), handler: (() => { this._disableControls("navigation-refresh"); this.mapControl.fitMap(); }), options: null },
            { action: "navigation-zoom-box", icon: "fal fa-mouse-pointer", title: this.resourcesHandler.get("Zoom box"), handler: this._getDragZoomHandler(), options: null },
            { action: "navigation-undo", icon: "ni ni-action-undo", title: this.resourcesHandler.get("Undo"), handler: this._getUndoHandler(), options: null },
            { action: "navigation-redo", icon: "ni ni-action-redo", title: this.resourcesHandler.get("Redo"), handler: this._getRedoHandler(), options: null }
        ];
    }

    init() {
        if (this._isMobileDevice()) return;

        $(this.menuContainer).append('<div class="map-toolbar toolbar-navigation shadow-4" style="display:none;"></div>');
        $(this.menuContainer).find(".toolbar-navigation").append('<ul class="map-toolbar-list"></ul>');

        for (var i = 0; i < this.toolbarActions.length; i++) {
            $(this.menuContainer).find(".map-toolbar-list").append('<li class="map-toolbar-item header-icon ' + this.toolbarActions[i].action + '" title="' + this.resourcesHandler.get(this.toolbarActions[i].title)
                + '"><i class="' + this.toolbarActions[i].icon + '"></i></li>');
            if (this.toolbarActions[i].options == null && this.toolbarActions[i].handler != null) {
                $(this.menuContainer).find("." + this.toolbarActions[i].action).click(this.toolbarActions[i].handler);
            }
            else if (this.toolbarActions[i].options != null && this.toolbarActions[i].options.length > 0) {
                $(this.menuContainer).find("." + this.toolbarActions[i].action).attr("data-toggle", "dropdown");
                $(this.menuContainer).find("." + this.toolbarActions[i].action).append('<div class="dropdown-menu"></div>');
                for (var j = 0; j < this.toolbarActions[i].options.length; j++) {
                    $(this.menuContainer).find("." + this.toolbarActions[i].action).find(".dropdown-menu").append(
                        '<a class="dropdown-item" data-action="' + this.toolbarActions[i].options[j].action + '" href="javascript:void(0)">' + this.toolbarActions[i].options[j].title + '</a>'
                    );
                    $(this.menuContainer).find("." + this.toolbarActions[i].action).find(".dropdown-item[data-action='" + this.toolbarActions[i].options[j].action + "']").click(this.toolbarActions[i].options[j].handler);
                }
            }
        }

        this._initMapHistory();
        this._initDragZoom();

        if ($('body:not(.nav-function-top)').length > 0) {
            $(this.menuContainer).find(".toolbar-navigation").css('right', $('.header-options').width() + 30);
        }

        $(this.menuContainer).find(".toolbar-navigation").show();
    }

    _isMobileDevice() {
        let supportsTouch = ('ontouchstart' in window || navigator.msMaxTouchPoints) && (window.innerWidth < 750);
        return supportsTouch;
    }

    _initMapHistory() {

        this.history = [];
        this.history_redo = [];
        this.history_item = null;

        this.disable_history_delay = 100;
        this.historyTimeout = null;


        $(this.menuContainer).find(".navigation-undo").addClass("disabled");
        $(this.menuContainer).find(".navigation-redo").addClass("disabled");


        this.mapControl.map.on('moveend', (e) => {

            var newItem = {
                center: this.mapControl.map.getView().getCenter(),
                resolution: this.mapControl.map.getView().getResolution()
            }

            if (this.history_item != null) {
                if (this.history_item.resolution == newItem.resolution && this.history_item.center[0] == newItem.center[0] && this.history_item.center[1] == newItem.center[1]) {
                    return;
                }
            }

            this.history_redo = [];
            $(this.menuContainer).find(".navigation-redo").addClass("disabled");

            this.history.push(newItem);
            if (this.history.length > 1) {
                $(this.menuContainer).find(".navigation-undo").removeClass("disabled");
            }

            return;

        });
    }

    _getUndoHandler() {

        var handler = () => {
            if (this.history.length > 1) {

                this._disableControls("navigation-undo");

                var item = this.history.pop();
                this.history_redo.push(item);
                $(this.menuContainer).find(".navigation-redo").removeClass("disabled");

                this.history_item = this.history[this.history.length - 1];
                this.mapControl.map.getView().animate({
                    center: this.history[this.history.length - 1].center,
                    resolution: this.history[this.history.length - 1].resolution,
                    duration: this.history_delay
                });

                if (this.history.length <= 1) {
                    $(this.menuContainer).find(".navigation-undo").addClass("disabled");
                }
            }
        };

        return handler;
    }

    _getRedoHandler() {

        var handler = () => {
            if (this.history_redo.length > 0) {

                this._disableControls("navigation-redo");

                var item = this.history_redo.pop();
                this.history.push(item);
                $(this.menuContainer).find(".navigation-undo").removeClass("disabled");

                this.history_item = item;
                this.mapControl.map.getView().animate({
                    center: item.center,
                    resolution: item.resolution,
                    duration: this.history_delay
                });

                if (this.history_redo.length == 0) {
                    $(this.menuContainer).find(".navigation-redo").addClass("disabled");
                }
            }
        };

        return handler;
    }

    _initDragZoom() {

        this.dragZoomInteraction = new DragZoom({ duration: 100, condition: (e) => { return true; } });
        this.mapControl.map.addInteraction(this.dragZoomInteraction);
        this.dragZoomInteraction.setActive(false);

        this.keydownEvent = (evt) => {
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if (charCode === 27) { //esc key
                this._disableDragZoom();
            }
        };
    }

    _getDragZoomHandler() {

        var handler = () => {
            this._disableControls("navigation-zoom-box");
            var ctrl = $(this.menuContainer).find(".navigation-zoom-box");
            if (ctrl.hasClass("active")) {
                this._disableDragZoom();
            }
            else {
                this.mapControl.clearSelection();
                this.dragZoomInteraction.setActive(true);
                ctrl.addClass("active");
                $(this.mapControl.target).css({ "cursor": "crosshair" });
                document.addEventListener('keydown', this.keydownEvent);
            }
        }

        return handler;
    }

    _disableDragZoom() {
        var ctrl = $(this.menuContainer).find(".navigation-zoom-box");
        this.dragZoomInteraction.setActive(false);
        ctrl.removeClass("active");
        $(this.mapControl.container).css({ "cursor": "default" });
        document.removeEventListener('keydown', this.keydownEvent);
    }

    _disableControls(btnPressed) {
        if (btnPressed != "navigation-zoom-box") {
            this._disableDragZoom();
        }
    }
}